import { pickSupportedMimeType, type RecordingFormat } from "./mime-types";

export async function recordCanvas(args: {
  canvas: HTMLCanvasElement;
  durationMs: number;
  format: RecordingFormat;
  fps?: number;
  videoBitsPerSecond?: number;
  onStatus?: (status: string) => void;
  start: () => void;
}): Promise<Blob> {
  if (typeof MediaRecorder === "undefined") {
    throw new Error("MediaRecorder is not available in this browser.");
  }
  const fps = args.fps ?? 30;
  const stream = args.canvas.captureStream(fps);
  const mimeType = pickSupportedMimeType(args.format);
  if (args.format === "mp4" && !mimeType) {
    throw new Error("MP4 recording is not supported in this browser. Export WebM instead.");
  }
  const recorder = new MediaRecorder(stream, {
    ...(mimeType ? { mimeType } : {}),
    ...(args.videoBitsPerSecond ? { videoBitsPerSecond: args.videoBitsPerSecond } : {})
  });
  const chunks: Blob[] = [];

  return new Promise((resolve, reject) => {
    recorder.ondataavailable = (event) => {
      if (event.data.size) chunks.push(event.data);
    };
    recorder.onerror = () => reject(new Error("Recording failed."));
    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: recorder.mimeType || (args.format === "mp4" ? "video/mp4" : "video/webm") });
      if (blob.size === 0) {
        reject(new Error("Recording produced an empty video file."));
        return;
      }
      resolve(blob);
    };
    recorder.start(250);
    args.onStatus?.("録画中");
    args.start();
    window.setTimeout(() => {
      if (recorder.state !== "inactive") {
        args.onStatus?.("仕上げ中");
        recorder.stop();
      }
      stream.getTracks().forEach((track) => track.stop());
    }, args.durationMs);
  });
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1200);
}
